// extracted by mini-css-extract-plugin
module.exports = {"student_count":"StudentCount_student_count__2VVKA"};